module.exports = __webpack_public_path__ + "img/candidate-test-count.470f0967.png";